import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants"
import { autoEuropePricingIdListData } from "Pages/AutoEuropeTool/PricingId/@signals"

const PRICING_ID_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/pricing-id`

export default function useAutoEuropePricingIdActions() {
	const { showToast } = useToast()

	const onDelete = useCallback((pricingRecordId) => {
		showToast.confirm("Are you sure you want to delete this Pricing ID record? This action cannot be undone.", {
			onSubmit: () => showToast.promise(
				postSubmit(`${PRICING_ID_API}/delete`, { pricing_record_id: pricingRecordId }),
				{
					onSuccess: () => {
						autoEuropePricingIdListData.value = autoEuropePricingIdListData.value.filter(
							item => item.pricingRecordId !== pricingRecordId
						)
					},
				}
			)
		})
	}, [])

	return { onDelete }
}